import { Group, Radio, Text } from '@mantine/core';
import classes from '@/pages/AutomationPage/components/ManualRunModal/components/PreviouslyUploadedFiles/PreviouslyUploadedFiles.module.css';
import { HiOutlineEye } from 'react-icons/hi2';
import StyledButton from '@/components/StyledButton/StyledButton.tsx';
import { formatCalendarStyle } from '@/utils/datetime.ts';
import { useViewDataset } from '@/hooks/useViewDataset.ts';
import DatasetIcon from '@/components/DatasetIcon.tsx';
import { TriggerDataset } from '@/types/datasets.ts';

type props = {
  triggerDataset: TriggerDataset;
  selectedExistingDatasetId: string | undefined;
  setSelectedExistingDatasetId: (id: string) => void;
};

const PreviouslyUploadedFile = ({
  triggerDataset,
  selectedExistingDatasetId,
  setSelectedExistingDatasetId,
}: props) => {
  const { setDatasetModalId } = useViewDataset();

  return (
    <Radio.Card
      key={triggerDataset.id}
      checked={triggerDataset.dataset.id === selectedExistingDatasetId}
      onClick={() => {
        setSelectedExistingDatasetId(triggerDataset.dataset.id);
      }}
      className={classes.radioCard}
      style={{ overflow: 'clip' }}
    >
      <Group
        justify={'space-between'}
        px={'8px'}
        py={'8px'}
        wrap={'nowrap'}
        w="100%"
        style={{ minWidth: 0 }}
        gap={'8px'}
      >
        <Group px={'2px'} gap={'8px'} wrap={'nowrap'} style={{ flex: 1, minWidth: 0 }}>
          <DatasetIcon dataset={triggerDataset.dataset} size={'20px'} />
          {/*<AppIcon*/}
          {/*  Icon={isDirectory(triggerDataset.dataset) ? HiOutlineFolder : HiOutlineDocument}*/}
          {/*  style={{ color: '#757575' }}*/}
          {/*/>*/}

          <Text
            size="sm"
            truncate={'end'}
            style={{ minWidth: 0 }}
            title={triggerDataset.dataset.name}
          >
            {triggerDataset.dataset.name}
          </Text>

          <StyledButton
            size={'sm'}
            variant={'subtleIcon'}
            aria-label={`View ${triggerDataset.dataset.name}`}
            w={'24px'}
            h={'24px'}
            className={classes.clickToView}
            onClick={async (e) => {
              e.stopPropagation();
              e.preventDefault();
              await setDatasetModalId(triggerDataset.dataset.id);
              // onClose?.();
            }}
            style={{ borderRadius: '50%' }}
            my={'-8px'}
            ml={'auto'}
          >
            <HiOutlineEye size={16} color={'#BABABA'} />
          </StyledButton>

          {/*<Flex*/}
          {/*  miw={'50px'}*/}
          {/*  my={'-8px'}*/}
          {/*  gap={'1px'}*/}
          {/*  className={classes.clickToView}*/}
          {/*  onClick={async (e) => {*/}
          {/*    e.stopPropagation();*/}
          {/*    e.preventDefault();*/}
          {/*    await setDatasetModalId(d.dataset.id);*/}
          {/*    // onClose?.();*/}
          {/*  }}*/}
          {/*  align={'center'}*/}
          {/*  px={'3px'}*/}
          {/*  py={'4px'}*/}
          {/*  style={{ borderRadius: '4px' }}*/}
          {/*  ml={'auto'}*/}
          {/*>*/}
          {/*  <Text size="xs" c="dimmed" style={{ lineHeight: '100%' }}>*/}
          {/*    Click to*/}
          {/*  </Text>*/}
          {/*  <Text size="xs" c="dimmed" style={{ lineHeight: '100%' }}>*/}
          {/*    view*/}
          {/*  </Text>*/}
          {/*</Flex>*/}
        </Group>
        <Group wrap={'nowrap'}>
          <Text size="xs" c="dimmed">
            {formatCalendarStyle(triggerDataset.created_at)}
          </Text>
          <Radio.Indicator className={classes.radioIndicator} />
        </Group>
      </Group>
    </Radio.Card>
  );
};

export default PreviouslyUploadedFile;
